export default [
  {
    name: "Frytkownica Air Fryer",
    code: "MFR-14M/WIFI",
    url: "https://mpm.pl/pl/frytkownice/3740-frytkownica-beztluszczowa-air-fryer-mfr-14mwifi-5903151079121.html",
    photo: "product1.png"
  },
  {
    name: "Suszarka do włosów",
    code: "MSW-26",
    url: "https://mpm.pl/pl/suszarki-do-wlosow/3700--suszarka-do-wlosow-msw-26-5903151081988.html",
    photo: "product2.png"
  },
  {
    name: "Bezprzewodowy mikser ręczny GoFree",
    code: "CMMR-01",
    url: "https://mpm.pl/pl/polecane-produkty/3664-akumulatorowy-mikser-reczny-cmmr-01-5903151074928.html",
    photo: "product3.png"
  },
  {
    name: "Bezprzewodowy blender personalny GoFree",
    code: "CMBL-02",
    url: "https://mpm.pl/pl/blendery/3663-akumulatorowy-blender-personalny-cmbl-02-5903151074904.html",
    photo: "product4.png"
  },
  {
    name: "Bezprzewodowy blender ręczny",
    code: "CMBL-01",
    url: "https://mpm.pl/pl/blendery/3665-blender-reczny-zestaw-cmbl-01-5903151074881.html",
    photo: "product5.png"
  },
  {
    name: "Pralka automatyczna",
    code: "MPM-5112-PT-44",
    url: "https://mpm.pl/pl/pralki/3730-pralka-automatyczna-mpm-5112-pt-44-5903151073273.html",
    photo: "product6.png"
  },
  {
    name: "Odkurzacz piorący",
    code: "MOD-49",
    url: "https://mpm.pl/pl/odkurzacze/3572-odkurzacz-pioracy-mod-49-5903151061324.html",
    photo: "product7.png"
  },
  {
    name: "Odkurzacz workowy",
    code: "MOD-52",
    url: "https://mpm.pl/pl/odkurzacze/3196-odkurzacz-workowy-mod-52-5903151039590.html",
    photo: "product8.png"
  },
  {
    name: "Suszarka do włosów",
    code: "MSW-27",
    url: "https://mpm.pl/pl/suszarki-do-wlosow/3724-suszarka-do-wlosow-msw-27-5903151083425.html",
    photo: "product9.png"
  }
];
